import { call, put } from 'redux-saga/effects'
import { takeEvery } from 'redux-saga'
import fetcher from 'modules/fetcher'
import {
  FETCH_UNREAD_NOTIFICATIONS,
  FETCH_DISMISSED_NOTIFICATIONS,
  MARK_READ,
  MARK_ALL_SEEN,
  MARK_ALL_READ,
  FETCH_LATEST_NOTIFICATIONS,
  FETCH_UNREAD_STATUS
} from './constants'
import {
  fetchUnreadNotifications,
  fetchDismissedNotifications,
  fetchLatestNotifications,
  fetchUnreadStatus,
  fetchUnreadNotificationsSuccess,
  fetchDismissedNotificationsSuccess,
  fetchLatestNotificationsSuccess,
  fetchUnreadStatusSuccess,
  markAllSeenSuccess
} from './actions'

function * fetchUnreadNotificationsSaga ({ payload }) {
  const { page, perPage } = payload
  try {
    const result = yield call(fetcher, `/notifications?scope=unread&page=${page}&per_page=${perPage}`, { method: 'GET' })
    yield put(fetchUnreadNotificationsSuccess(result))
  } catch (error) {
    console.error(error.message)
  }
}

function * fetchDismissedNotificationsSaga ({ payload }) {
  const { page, perPage } = payload
  try {
    const result = yield call(fetcher, `/notifications?scope=read&page=${page}&per_page=${perPage}`, { method: 'GET' })
    yield put(fetchDismissedNotificationsSuccess(result))
  } catch (error) {
    console.error(error.message)
  }
}

function * fetchLatestNotificationsSaga () {
  try {
    const result = yield call(fetcher, '/notifications/latest', { method: 'GET' })
    yield put(fetchLatestNotificationsSuccess(result))
  } catch (error) {
    console.error(error.message)
  }
}

function * fetchUnreadStatusSaga () {
  try {
    const result = yield call(fetcher, '/notifications/unread_status', { method: 'GET' })
    yield put(fetchUnreadStatusSuccess(result))
  } catch (error) {
    console.error(error.message)
  }
}

function * markReadSaga ({ payload }) {
  const { id, currentUnreadPage, currentUnreadPerPage, currentDismissedPage, currentDismissedPerPage } = payload
  try {
    yield call(fetcher, `/notifications/${id}/mark_read`, { method: 'POST' })
    yield put(fetchUnreadNotifications({ page: currentUnreadPage, perPage: currentUnreadPerPage }))
    yield put(fetchDismissedNotifications({ page: currentDismissedPage, perPage: currentDismissedPerPage }))
    yield put(fetchLatestNotifications())
    yield put(fetchUnreadStatus())
  } catch (error) {
    console.error(error.message)
  }
}

function * markAllSeenSaga ({ payload }) {
  const { ids } = payload
  // Only caller is the bell's onPanelClose handler. If there are no ids to mark, skip
  // the whole flow — no server call, no refetches. The previous code in this case
  // triggered mark_all_seen + unread + dismissed + latest + unread_status (5 requests)
  // even though nothing changed.
  if (!ids?.length) return

  try {
    yield call(fetcher, `/notifications/mark_all_seen?ids=${ids.join(',')}`, { method: 'POST' })
    yield put(markAllSeenSuccess(ids))
    yield put(fetchUnreadStatus())
  } catch (error) {
    console.error(error.message)
  }
}

function * markAllReadSaga ({ payload }) {
  const { ids } = payload
  try {
    yield call(fetcher, '/notifications/mark_all_read' + idParams(ids), { method: 'POST' })
    yield put(fetchUnreadNotifications())
    yield put(fetchDismissedNotifications())
    yield put(fetchLatestNotifications())
    yield put(fetchUnreadStatus())
  } catch (error) {
    console.error(error.message)
  }
}

export function * watchNotificationsFetchedSaga () {
  yield takeEvery(FETCH_UNREAD_NOTIFICATIONS, fetchUnreadNotificationsSaga)
  yield takeEvery(FETCH_DISMISSED_NOTIFICATIONS, fetchDismissedNotificationsSaga)
  yield takeEvery(FETCH_LATEST_NOTIFICATIONS, fetchLatestNotificationsSaga)
  yield takeEvery(FETCH_UNREAD_STATUS, fetchUnreadStatusSaga)
  yield takeEvery(MARK_READ, markReadSaga)
  yield takeEvery(MARK_ALL_SEEN, markAllSeenSaga)
  yield takeEvery(MARK_ALL_READ, markAllReadSaga)
}

export const notificationsFetchedSagas = [watchNotificationsFetchedSaga()]

const idParams = (ids) => ids.length > 0 ? '?ids=' + ids.join(',') : ''
